import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useForm, Controller } from "react-hook-form";
import PassportPhotoInput from "./PassportPhotoInput";
import Navbar from "./Navbar";
import ReusableProgessBar from "components/common/ReusableProgessBar";
import CrossIcon from "../../../../assets/img/cross-icon.png";
import DirectionLine from "./DirectionLine.js";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import axios from "axios";
import { fetchgetInvitedUserDetailsById } from "../../../../../src/redux/slice/getInvitedUserDetailsSlice";
import { submitAllFormData } from "../../../../../src/redux/formApiActions";
import { toast, ToastContainer } from "react-toastify";
import useUploadPreOnboardingDocs from "../../../../../src/hooks/useUploadPreOnboardingDocs";
import { fetchgetPreOnboardingDocsById } from "../../../../../src/redux/slice/getPreOnboardingDocsByIdSlice";
import ValidateFile from "../../../../utils/ValidateFile";

export default function PersonalDetailsForm() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
    setValue,
    clearErrors,
    unregister,
    getValues,
    trigger,
  } = useForm();
  const InviteData = useSelector(
    (state) => state.persistedReducer.forms.inviteData,
  );
  const paramId = InviteData?.id;
  const { getInvitedUserDetailsById, status, error } = useSelector(
    (state) => state.getInvitedUserDetailsById,
  );

  const fileInputRefs = useRef({});
  const docs = useSelector((state) => state.getPreOnboardingDocsById.docs);
  const [doc, setDoc] = useState({
    fileForAadhar: null,
    fileForPan: null,
    photo: null,
  });

  const [pattern, setPattern] = useState({
    firstName: "",
    middleName: "",
    lastName: "",
    motherName: "",
    fatherName: "",
    mob: "",
    aadharNo: "",
    panNo: "",
    email: "",
  });

  const [docError, setDocError] = useState({
    photoError: false,
    panError: false,
    aadhaarError: false,
  });

  const [countriesOptions, setCountriesOptions] = useState([]);
  const [nationalityOptions, setNationalityOptions] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [selectedNationality, setSelectedNationality] = useState(null);
  const INDIA_OPTION = {
    value: "India",
    label: "India",
    demonyms: {
      eng: {
        m: "Indian",
        f: "Indian",
      },
    },
  };

  useEffect(() => {
    dispatch(fetchgetInvitedUserDetailsById(paramId));
  }, []);
  useEffect(() => {
    if (status === "failed" && error && error.shouldNavigate) {
      navigate("/email-verification");
    }
  }, [status, error, navigate]);

  useEffect(() => {
    if (getInvitedUserDetailsById) {
      prefillInvitedUser();
    }
  }, [getInvitedUserDetailsById]);

  useEffect(() => {
    if (getInvitedUserDetailsById?.addresses?.length > 0) {
      const permAddrData = addresses.find(addr => addr.addressType === "PERMANENT") || {};
      const countryName = permAddrData?.country;
      const initialCountry = countriesOptions.find(
        (opt) => opt.value === countryName,
      );

      if (initialCountry) {
        setSelectedCountry(initialCountry);
        setValue("country", initialCountry.value);
        handleCountrySelect(initialCountry);
      }
    }
  }, [getInvitedUserDetailsById, countriesOptions]);

  const { addresses, personalDetail } = getInvitedUserDetailsById ?? {};
  const savedData = personalDetail;

  useEffect(() => {
    if (addresses?.length > 0) setSelectedCountry(addresses[0].country);
  }, [addresses, getInvitedUserDetailsById]);
  useEffect(() => {
    if (nationalityOptions.length === 1) {
      const val = nationalityOptions[0].value;
      setValue("nationality", val);
      clearErrors("nationality");
    }
  }, [nationalityOptions, setValue, clearErrors]);

  // Fetch all countries on mount
  useEffect(() => {
    const fetchCountries = async () => {
      try {
        const res = await axios.get(
          "https://restcountries.com/v3.1/all?fields=name,demonyms",
        );
        const options = res.data
          .map((c) => ({
            value: c.name.common,
            label: c.name.common,
            demonyms: c.demonyms,
          }))
          .sort((a, b) => a.label.localeCompare(b.label));
        setCountriesOptions(options);

        if (savedData?.country) {
          const found = options.find(o => o.value === savedData.country);
          if (found) { handleCountrySelect(found); }
        } else {
          handleCountrySelect(INDIA_OPTION);
        }
      } catch (err) {
        console.error(err);
        // API fail hone par India fallback
        setCountriesOptions([INDIA_OPTION]);
        setSelectedCountry(INDIA_OPTION);
        setValue("country", "India");
        setValue("nationality", "Indian");
        setNationalityOptions([{ value: "Indian", label: "Indian", },]);
        setSelectedNationality({ value: "Indian", label: "Indian", });
      }
      // } catch (err) {
      //   console.error(err);
      // }
    };
    fetchCountries();
  }, [savedData]);

  useEffect(() => {
    if (!savedData) return;

    const savedAadharRaw = savedData.adhaarNo ?? savedData.aadharNo ?? "";
    const savedAadharFormatted = formatAadhar(savedAadharRaw);

    setValue("firstName", getInvitedUserDetailsById?.firstName || "");
    setValue("middleName", getInvitedUserDetailsById?.middleName || "");
    setValue("lastName", getInvitedUserDetailsById?.lastName || "");
    setValue(
      "email",
      getInvitedUserDetailsById.personalEmail || savedData.email || "",
    );
    setValue("gender", savedData.gender || "");
    setValue("motherName", savedData.motherName || "");
    setValue("fatherName", savedData.fatherName || "");
    setValue("uanNo", savedData.uanNo || "");
    setValue("country", savedData.country || "");
    setValue("nationality", savedData.nationality || "");
    setValue("aadharNo", savedAadharFormatted || "");
    setValue("panNo", savedData.panNo || "");
    setValue("mob", savedData.secondaryMobile || savedData.mob || "");

    setPattern((prev) => ({
      ...prev,
      firstName: getInvitedUserDetailsById?.firstName || "",
      middleName: getInvitedUserDetailsById?.middleName || "",
      lastName: getInvitedUserDetailsById?.lastName || "",
      motherName: savedData.motherName || "",
      fatherName: savedData.fatherName || "",
      mob: savedData.secondaryMobile || savedData.mob || "",
      aadharNo: savedAadharFormatted || "",
      panNo: savedData.panNo || "",
      email: savedData.personalEmail || savedData.email || "",
    }));

    const adhaarUrl = savedData.adhaarUrl ?? null;
    const panUrl = savedData.panUrl ?? null;
    const photoUrl = savedData.imageUrl ?? savedData.photo ?? null;

    setDoc({
      fileForAadhar: adhaarUrl ? { file: null, url: adhaarUrl } : null,
      fileForPan: panUrl ? { file: null, url: panUrl } : null,
      photo: photoUrl ? { file: null, url: photoUrl } : null,
    });
  }, [personalDetail, savedData, setValue, getInvitedUserDetailsById]);

  useEffect(() => {
    unregister(["otp0", "otp1", "otp2", "otp3", "otp4", "otp5"]);
  }, [unregister]);

  useEffect(() => {
    docTypes.forEach((type) => {
      dispatch(fetchgetPreOnboardingDocsById({ type, id: paramId }));
    });
  }, []);

  useEffect(() => {
    setDoc({
      fileForAadhar: docs.aadhaarCard
        ? { file: null, url: docs.aadhaarCard }
        : null,
      fileForPan: docs.panCard ? { file: null, url: docs.panCard } : null,
      photo: docs.passportPhoto
        ? { file: null, url: docs.passportPhoto }
        : null,
    });

  }, [docs, dispatch]);

  const { handleFileUpload } = useUploadPreOnboardingDocs();

  const prefillInvitedUser = () => {
    const invitedDetails = getInvitedUserDetailsById ?? {};

    const { firstName, middleName, lastName, personalEmail, mobile } =
      invitedDetails ?? "";
    setValue("firstName", firstName || "");
    setValue("middleName", middleName || "");
    setValue("lastName", lastName || "");
    setValue("email", personalEmail || "");
    setValue("mainMob", mobile || "");

    setPattern((prev) => ({
      ...prev,
      firstName: firstName || "",
      middleName: middleName || "",
      lastName: lastName || "",
      email: personalEmail || "",
      mainMob: mobile || "",
    }));
  };

  const formatAadhar = (digits) => {
    if (!digits) return "";
    const d = digits.replaceAll(/\D/g, "").slice(0, 12);
    const groups = d.match(/.{1,4}/g);
    return groups ? groups.join("-") : d;
  };

  const formatPan = (val) => {
    if (!val) return "";
    return val
      .toString()
      .toUpperCase()
      .replaceAll(/[^A-Z0-9]/g, "")
      .slice(0, 10);
  };

  const handleCountrySelect = async (option) => {
    setSelectedCountry(option);
    setValue("country", option.value);
    clearErrors("country");

    if (option.demonyms) {
      const demonymsEng = option.demonyms.eng;
      const options = [];

      if (demonymsEng?.m)
        options.push({ value: demonymsEng.m, label: demonymsEng.m });
      if (demonymsEng?.f && demonymsEng.f !== demonymsEng?.m) {
        options.push({ value: demonymsEng.f, label: demonymsEng.f });
      }

      if (options.length === 1) {
        setNationalityOptions(options);
        setSelectedNationality(options[0]);
        setValue("nationality", options[0].value);
      } else if (options.length > 1) {
        setNationalityOptions(options);
        setSelectedNationality(null);
        setValue("nationality", "");
      } else {
        setNationalityOptions([]);
        setSelectedNationality(null);
        setValue("nationality", option.value);
      }
    } else {
      setNationalityOptions([]);
      setSelectedNationality(null);
      setValue("nationality", option.value);
    }
  };

  const handleNationalitySelect = (option) => {
    setSelectedNationality(option);
    setValue("nationality", option.value);
    clearErrors("nationality");
  };

  const validateField = async (name) => {
    try {
      const result = await trigger(name);
      return result;
    } catch (err) {
      return false;
    }
  };

  const handlePatternForPersonalDetailInputs = (e, regex, field) => {
    let value = e.target.value ?? "";
    if (["firstName", "middleName", "lastName"].includes(field)) {
      value = value.replaceAll(/[^A-Za-z]/g, "");
      setPattern((prev) => ({ ...prev, [field]: value }));
      clearErrors(field);
      return;
    }
    if (field === "mob") {
      value = value.replaceAll(/\D/g, "");
      if (value.length > 10) value = value.slice(0, 10);
      setPattern((prev) => ({ ...prev, mob: value }));
      clearErrors("mob");
      return;
    }
    if (field === "aadharNo") {
      let digits = value.replaceAll(/\D/g, "");
      if (digits.length > 12) digits = digits.slice(0, 12);
      const groups = digits.match(/.{1,4}/g);
      const formatted = groups ? groups.join("-") : digits;
      setPattern((prev) => ({ ...prev, aadharNo: formatted }));
      clearErrors("aadharNo");
      return;
    }
    if (field === "panNo") {
      let upper = value.toUpperCase().replaceAll(/[^A-Z0-9]/g, "");
      if (upper.length > 10) upper = upper.slice(0, 10);
      setPattern((prev) => ({ ...prev, panNo: upper }));
      clearErrors("panNo");
      return;
    }
    setPattern((prev) => ({ ...prev, [field]: value }));
    clearErrors(field);
  };

  const handleFileForDocs = (e, field) => {
    const file = e?.target?.files?.[0];
    if (!file && doc[field]?.url) return;
    if (!file) {
      setDoc((prev) => ({ ...prev, [field]: null }));
      return;
    }
    let allowedTypes = [];
    if (field === "photo") {
      allowedTypes = ["image/jpeg", "image/png", "image/jpg"];
    }
    if (["fileForAadhar", "fileForPan"].includes(field)) {
      allowedTypes = ["application/pdf", "image/jpeg", "image/jpg", "image/png"];
    }
    const validate = ValidateFile(file, allowedTypes);

    if (validate !== true) {
      toast.error(validate);
      return;
    }
    if (field === "fileForPan") {
      handleFileUpload(file, "panCard", paramId);
    }
    if (field === "fileForAadhar") {
      handleFileUpload(file, "aadhaarCard", paramId);
    }
    setDocError({
      photoError: !doc.photo,
      panError: !doc.fileForPan,
      aadhaarError: !doc.fileForAadhar,
    });
    const url = URL.createObjectURL(file);
    setDoc((prev) => ({ ...prev, [field]: { file, url } }));
  };

  const handleRemoveFile = (field) => {
    setDoc((prev) => ({ ...prev, [field]: null }));
    if (fileInputRefs.current[field]) fileInputRefs.current[field].value = "";
  };

  const handleSaveDraft = () => {
    try {
      const data = getValues();
      const payload = {
        firstName: data.firstName || pattern.firstName || "",
        middleName: data.middleName || pattern.middleName || "",
        lastName: data.lastName || pattern.lastName || "",
        fatherName: data.fatherName || "",
        motherName: data.motherName || "",
        gender: data.gender || "",
        personalEmail: data.email || pattern.email || "",
        secondaryMobile: data.mob || pattern.mob || "",
        adhaarNo: pattern.aadharNo || formatAadhar(data.aadharNo || ""),
        panNo: pattern.panNo || formatPan(data.panNo || ""),
        uanNo: data.uanNo || "",
        nationality: data.nationality || "",
        country: data.country || "",
      };

      const hasAnyValue = Object.values(payload).some(
        (val) => val && val.toString().trim() !== "",
      );

      if (!hasAnyValue) {
        toast.warn("Please fill at least one field before saving as draft!");
        return;
      }
      const permAddrData = addresses.find(addr => addr.addressType === "PERMANENT") || addresses[0] || {};
      const currAddrData = addresses.find(addr => addr.addressType === "CURRENT") || addresses[1] || { addressType: "CURRENT" };

      const AddressesPayload = [
        {
          ...permAddrData,
          addressType: "PERMANENT",
          nationality: data.nationality || "",
          country: data.country || "",
        },
        {
          ...currAddrData,
        },
      ];

      const finalPayload = {
        personalDetail: payload,
        addresses: AddressesPayload,
        type: "PARTIAL_UPDATE",
        status: "DRAFT",
      };
      dispatch(submitAllFormData(finalPayload, paramId, "draft"));
    } catch (error) {
      toast.error("Failed to save draft. Please try again!");
      throw (error)
    }
  };

  const handleFormSubmit = async (formValues) => {
    if (!doc.fileForAadhar || !doc.fileForPan || !doc.photo) {
      setDocError({
        photoError: !doc.photo,
        panError: !doc.fileForPan,
        aadhaarError: !doc.fileForAadhar,
      });
      return;
    }
    const aadharDigits = (
      pattern.aadharNo ||
      formValues.aadharNo ||
      ""
    ).replaceAll(/\D/g, "");
    if (!aadharDigits || aadharDigits.length !== 12) {
      alert("Aadhaar must be 12 digits");
      return;
    }
    const panValue = (formValues.panNo || "").toUpperCase();
    if (!panValue || panValue.length !== 10) {
      alert("PAN must be 10 characters");
      return;
    }
    if (!formValues.country || !formValues.nationality) {
      alert("Country and Nationality cannot be blank");
      return;
    }
    const finalAadharFormatted = pattern.aadharNo || formatAadhar(aadharDigits);
    const payload = {
      fatherName: formValues.fatherName || "",
      motherName: formValues.motherName || "",
      gender: formValues.gender || "",
      secondaryMobile: formValues.mob || "",
      adhaarNo: finalAadharFormatted,
      panNo: panValue,
      uanNo: formValues.uanNo || "",
    };
    const permAddrData = addresses.find(addr => addr.addressType === "PERMANENT") || addresses[0] || {};
    const currAddrData = addresses.find(addr => addr.addressType === "CURRENT") || addresses[1] || { addressType: "CURRENT" };
    const AddressesPayload = [
      {
        ...permAddrData,
        addressType: "PERMANENT",
        nationality: formValues.nationality || "",
        country: formValues.country || "",
      },
      {
        ...currAddrData,
      },
    ];
    const finalPayload = {
      personalDetail: payload,
      addresses: AddressesPayload,
      type: "FULL_UPDATE",
      status: "PARTIAL_COMPLETED",
    };
    dispatch(submitAllFormData(finalPayload, paramId, "saveandnext"));
  };

  const docTypes = ["passportPhoto", "panCard", "aadhaarCard"];
  if (status === "loading") return (<div></div>);
  if (error) return;
  return (

    <div className="wrapper">
      <Navbar onMenuClick={() => setSidebarOpen(!sidebarOpen)} />
      <div className={`sidebar ${sidebarOpen ? "open" : ""}`}>
        <div className="sidebar-wrapper 3">
          <ReusableProgessBar />
        </div>
      </div>
      <div className="main-panel">
        <div className="form-content">
          <div className="container-fluid form-navbar">
            <div className="personaldetail-form">
              <DirectionLine />
              <div className="personalDetailForm">
                <div className="personalDetailHeading">
                  <h6 className="personalDetailHeadline">PERSONAL DETAILS</h6>
                </div>
                <form
                  onSubmit={handleSubmit(handleFormSubmit)}
                  className="personalDetailContainer"
                >
                  <div className="form-row">
                    <div className="form-group col-md-12 user-photo">
                      <PassportPhotoInput
                        prefilledUrl={doc.photo?.url ?? null}
                        handleFileForDocs={(fileObj) => {
                          if (!fileObj) {
                            setDoc((prev) => ({ ...prev, photo: null }));
                            return;
                          }
                          const file = fileObj.file || null;
                          const url =
                            fileObj.url ||
                            (fileObj instanceof File
                              ? URL.createObjectURL(fileObj)
                              : fileObj);
                          setDoc((prev) => ({
                            ...prev,
                            photo: { file, url },
                          }));
                          handleFileUpload(file, "passportPhoto", paramId);
                        }}
                        errors={errors}
                      />
                      {!doc.photo && docError.photoError && (
                        <div className="errorMessage text-center w-full">
                          Passport photo is required
                        </div>
                      )}
                    </div>

                    <div className="row col-md-12 pl-3 pr-1 mb-0">
                      <div className="form-group col-md-4 pl-1 pr-1">
                        <label htmlFor="firstName">
                          First Name (as per Aadhar/PAN){" "}
                          <span className="required">*</span>
                        </label>
                        <div className="prefilledValue form-control firstNameInput text-left disabled-value">
                          {pattern.firstName || "N/A"}
                        </div>
                      </div>
                      <div className="form-group col-md-4 pl-2 pr-2">
                        <label htmlFor="middleName">Middle Name</label>
                        <div className="prefilledValue form-control lastNameInput text-left disabled-value">
                          {pattern.middleName || "N/A"}
                        </div>
                      </div>
                      <div className="form-group col-md-4 pl-2 pr-0">
                        <label htmlFor="lastName">Last Name</label>
                        <div className="prefilledValue form-control lastNameInput text-left disabled-value">
                          {pattern.lastName || "N/A"}
                        </div>
                      </div>
                    </div>
                    <div className="row col-md-12 pl-3 pr-1 mb-0">
                      <div className="form-group col-md-4 pl-1 pr-1">
                        <label htmlFor="email">
                          Email <span className="required">*</span>
                        </label>
                        <div className="prefilledValue form-control lastNameInput text-left disabled-value">
                          {/* {getInvitedUserDetailsById?.personalEmail || "N/A"} */}
                          {pattern.email || getValues("email") || "N/A"}
                        </div>
                      </div>
                      <div className="form-group col-md-4 pl-2 pr-2">
                        <label htmlFor="email">
                          Mobile No. <span className="required">*</span>
                        </label>
                        <div className="prefilledValue form-control lastNameInput text-left disabled-value">
                          {pattern.mainMob || "N/A"}
                        </div>
                      </div>
                      <div className="form-group col-md-4 pl-2 pr-0">
                        <label htmlFor="gender" className="genderLabel">
                          {" "}
                          Gender <span className="required">*</span>{" "}
                        </label>
                        <select
                          id="gender"
                          className={`form-control selectGenderInput ${errors.gender ? "invalid" : ""}`}
                          {...register("gender", {
                            required: true,
                            onBlur: () => validateField("gender"),
                          })}


                        >

                          <option value="" hidden style={{ color: "#d3d3d3" }}>
                            {errors.gender
                              ? "⚠ Gender is required"
                              : "--Select Gender--"}
                          </option>
                          <option style={{ color: "black" }}>Male</option>
                          <option style={{ color: "black" }}>Female</option>
                          <option style={{ color: "black" }}>Other</option>
                        </select>
                        {errors.gender && (
                          <div className="errorMessage">
                            {errors.gender.message}
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="form-group col-md-6">
                      <label htmlFor="motherName">
                        Mother Name <span className="required">*</span>
                      </label>
                      <input id="motherName" type="text"
                        placeholder={errors.motherName ? "⚠ Mother Name is required" : "Mother Name"}
                        className={`form-control motherNameInput ${errors.motherName ? "invalid" : ""}`}
                        {...register("motherName", {
                          required: true,
                          minLength: { value: 2, message: "Mother's name must be at least 2 characters", },
                          maxLength: { value: 50, message: "Max 50 chars" },
                          pattern: {
                            value: /^[A-Za-z ]+$/,
                            message: "Only letters allowed",
                          },
                          onChange: (e) => {
                            const value = e.target.value;
                            if (/^[A-Za-z ]*$/.test(value)) {
                              setValue("motherName", value, {
                                shouldValidate: true,
                              });
                            }
                          },
                          onBlur: () => validateField("motherName"),
                          onKeyUp: () => validateField("motherName"),
                        })}
                      />
                      {errors.motherName && (
                        <div className="errorMessage">
                          {errors.motherName.message}
                        </div>
                      )}
                    </div>
                    <div className="form-group col-md-6">
                      <label htmlFor="fatherName">
                        Father Name <span className="required">*</span>
                      </label>
                      <input
                        id="fatherName"
                        type="text"
                        placeholder={
                          errors.fatherName
                            ? "⚠ Father Name is required"
                            : "Father Name"
                        }
                        className={`form-control fatherNameInput ${errors.fatherName ? "invalid" : ""}`}
                        {...register("fatherName", {
                          required: true,
                          minLength: { value: 2, message: "Father's name must be at least 2 characters", },
                          maxLength: { value: 50, message: "Max 50 chars" },
                          pattern: {
                            value: /^[A-Za-z ]+$/,
                            message: "Only letters allowed",
                          },
                          onChange: (e) => {
                            const value = e.target.value;
                            if (/^[A-Za-z ]*$/.test(value)) {
                              setValue("fatherName", value, {
                                shouldValidate: true,
                              });
                            }
                          },
                          onBlur: () => validateField("fatherName"),
                          onKeyUp: () => validateField("fatherName"),
                        })}
                        value={pattern.fatherName}
                        onChange={(e) =>
                          handlePatternForPersonalDetailInputs(
                            e,
                            /^[A-Za-z ]*$/,
                            "fatherName",
                          )
                        }
                      />
                      {errors.fatherName && (
                        <div className="errorMessage">
                          {errors.fatherName.message}
                        </div>
                      )}
                    </div>
                    <div className="form-group col-md-6">
                      <label htmlFor="UAN">UAN No.</label>
                      {/* <input id="UAN" type="text" placeholder="UAN Number" className="form-control uanInput" {...register("uanNo")} /> */}
                      <input
                        id="UAN"
                        type="text"
                        maxLength={12}
                        placeholder="UAN Number"
                        className={`form-control uanInput ${errors.uanNo ? "invalid" : ""}`}
                        {...register("uanNo", {
                          pattern: {
                            value: /^\d{12}$/,
                            message: "UAN must be exactly 12 digits",
                          },
                          onChange: (e) => {
                            const value = e.target.value;
                            if (/^\d*$/.test(value)) {
                              setValue("uanNo", value, {
                                shouldValidate: true,
                              });
                            }
                          },
                        })}
                      />

                      {errors.uanNo && (
                        <div className="errorMessage">
                          {errors.uanNo.message}
                        </div>
                      )}
                    </div>
                    <div className="form-group col-md-6">
                      <label htmlFor="country">
                        Country <span className="required">*</span>
                      </label>
                      <Controller
                        name="country"
                        control={control}
                        rules={{ required: true }}
                        render={({ field }) => (
                          <Select
                            {...field}
                            //options={countriesOptions}
                            options={
                              countriesOptions.length
                                ? countriesOptions
                                : [INDIA_OPTION]
                            }
                            value={
                              (
                                countriesOptions.length
                                  ? countriesOptions
                                  : [INDIA_OPTION]
                              ).find(
                                option => option.value === field.value
                              )
                              ||
                              (
                                countriesOptions.length
                                  ? countriesOptions
                                  : [INDIA_OPTION]
                              )[0]
                            }
                            onChange={(option) => {
                              field.onChange(option.value);
                              handleCountrySelect(option);
                              trigger("country");
                            }}
                            placeholder={
                              errors.country
                                ? "⚠ Country is required"
                                : "---Select Country---"
                            }
                            isSearchable
                            classNamePrefix="react-select"
                            className={`form-control1 countryInput ${errors.country ? "invalid" : ""
                              }`}
                          />
                        )}
                      />
                      {errors.country && (
                        <div className="errorMessage">
                          {errors.country.message}
                        </div>
                      )}
                    </div>

                    <div className="form-group col-md-6">
                      <label htmlFor="nationality">
                        Nationality <span className="required">*</span>
                      </label>
                      {nationalityOptions.length === 1 ? (
                        <input
                          type="text"
                          className={`form-control nationalityInput ${errors.nationality ? "invalid" : ""}`}
                          value={nationalityOptions[0].label}
                          readOnly
                        />
                      ) : (
                        <Controller
                          name="nationality"
                          control={control}
                          rules={{ required: true }}
                          render={({ field }) => (
                            <Select
                              {...field}
                              options={nationalityOptions}
                              value={selectedNationality}
                              onChange={(option) => {
                                field.onChange(option.value);
                                handleNationalitySelect(option);
                                trigger("nationality");
                              }}
                              placeholder={
                                errors.nationality
                                  ? "⚠ Nationality is required"
                                  : "---Select Nationality---"
                              }
                              isSearchable
                              classNamePrefix="react-select"
                              className={`form-control1 nationalityInput ${errors.nationality ? "invalid" : ""}`}
                            />
                          )}
                        />
                      )}
                      {errors.nationality && (
                        <div className="errorMessage">
                          {errors.nationality.message}
                        </div>
                      )}
                    </div>

                    <div className="form-group col-md-6">
                      <div className="inputWrapper">
                        <label htmlFor="aadhaarNo">
                          Aadhaar Details <span className="required">*</span>
                        </label>
                        <div className="inputWithFileName">
                          <div className="inputWithIcon">
                            <input id="aadhaarNo" type="text"
                              placeholder={
                                errors.aadharNo
                                  ? "⚠ Enter valid Aadhaar number (1234-1234-1234) and upload a copy"
                                  : "1234-1234-1234 and upload copy"
                              }
                              className={`form-control aadharInput ${errors.aadharNo ? "invalid" : ""}`}
                              {...register("aadharNo", {
                                required: true,
                                minLength: { value: 12, message: "Aadhar no. must be of 12-digits", },
                                onBlur: () => validateField("aadharNo"),
                                onKeyUp: () => validateField("aadharNo"),
                              })}
                              value={pattern.aadharNo}
                              onChange={(e) => handlePatternForPersonalDetailInputs(e, /^\d+$/, "aadharNo",)
                              }
                            />
                            <input type="file"
                              ref={(el) =>
                                (fileInputRefs.current["fileForAadhar"] = el)
                              }
                              onChange={(e) =>
                                handleFileForDocs(e, "fileForAadhar")
                              }
                              style={{ display: "none" }}
                            />
                            <button type="button" className="btn-interactive 1"
                              onClick={() =>
                                fileInputRefs.current[
                                  "fileForAadhar"
                                ]?.click()
                              }
                            >
                              <img
                                src={require("assets/img/upload-icon.png")}
                                alt="Upload"
                                className="upload-icon front-cta-img cursor-pointer"
                              />
                            </button>                             
                          </div>
                          <small className="help-text">
                            Please upload Aadhaar copy (Format: PDF, PNG, JPG, or JPEG | Max Size: 10MB)
                          </small>
                          {errors.aadharNo && (
                            <div className="errorMessage">
                              {errors.aadharNo.message}
                            </div>
                          )}
                          {!doc.fileForAadhar && docError.aadhaarError && (
                            <div className="errorMessage">
                              Aadhaar document is required
                            </div>
                          )}
                          <div className="file-upload-icon">
                            {doc.fileForAadhar?.url && (
                              <a href={doc.fileForAadhar.url}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="view-file-link"
                              >
                                View
                              </a>
                            )}
                            {doc.fileForAadhar && (
                              <button type="button" className="btn-interactive 2"
                                onClick={() =>
                                  handleRemoveFile("fileForAadhar")
                                }
                              >
                                <img src={CrossIcon} alt="" className="RemoveFileIcon" style={{ width: 20, height: 20 }} />
                              </button>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="form-group col-md-6">
                      <div className="inputWrapper">
                        <label htmlFor="panNo">
                          PAN Details <span className="required">*</span>

                        </label>
                        <div className="inputWithFileName">
                          <div className="inputWithIcon">
                            <input
                              id="panNo"
                              type="text"
                              maxLength={10}
                              placeholder={
                                errors.panNo
                                  ? "⚠ Enter valid PAN number (ABCDE1234F) and upload a copy"
                                  : "PAN Number and upload copy"
                              }
                              className={`form-control panInput ${errors.panNo ? "invalid" : ""}`}
                              {...register("panNo", {
                                required: true,
                                pattern: {
                                  value: /^[A-Z]{5}\d{4}[A-Z]{1}$/,
                                  message: "Invalid PAN format (ABCDE1234F)",
                                },
                                onChange: (e) => {
                                  const value = e.target.value.toUpperCase();
                                  if (/^[A-Z0-9]*$/.test(value)) {
                                    setValue("panNo", value, {
                                      shouldValidate: true,
                                    });
                                  }
                                },
                              })}
                            />

                            <input
                              type="file"
                              ref={(el) =>
                                (fileInputRefs.current["fileForPan"] = el)
                              }
                              onChange={(e) =>
                                handleFileForDocs(e, "fileForPan")
                              }
                              style={{ display: "none" }}
                            />
                            <button
                              type="button"
                              className="btn-interactive 3"
                              onClick={() =>
                                fileInputRefs.current["fileForPan"]?.click()
                              }
                            >
                              <img
                                src={require("assets/img/upload-icon.png")}
                                alt="Upload"
                                className="upload-icon"


                              />
                            </button>
                          </div>
                          <small className="help-text">
                            Please upload PAN copy (Format: PDF, PNG, JPG, or JPEG | Max Size: 10MB)
                          </small>
                          {errors.panNo && (
                            <div className="errorMessage">
                              {errors.panNo.message}
                            </div>
                          )}
                          {!doc.fileForPan && docError.panError && (
                            <div className="errorMessage">
                              Pan document is required
                            </div>
                          )}

                          <div className="file-upload-icon">
                            {doc.fileForPan?.url && (
                              <a href={doc.fileForPan.url}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="view-file-link"
                              >
                                View
                              </a>
                            )}
                            {doc.fileForPan && (
                              <button type="button"
                                className="btn-interactive 4"
                                onClick={() => handleRemoveFile("fileForPan")}
                              >
                                <img
                                  src={CrossIcon}
                                  alt=""
                                  className="RemoveFileIcon"

                                  style={{ width: 20, height: 20 }}
                                />
                              </button>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="form-group col-md-6">
                      <label htmlFor="alterNo">Alternative Mob. No. </label>
                      <input
                        id="alterNo"
                        type="tel"
                        inputMode="numeric"
                        maxLength={10}
                        placeholder="Alternate Mobile No."
                        className={`form-control mobInput ${errors.mob ? "invalid" : ""}`}
                        {...register("mob", {
                          validate: (value) => {
                            if (!value) return true;
                            return (
                              /^[6-9]\d{9}$/.test(value) ||
                              "Enter valid 10-digit mobile number"
                            );
                          },
                          onChange: (e) => {
                            const value = e.target.value;
                            if (/^\d*$/.test(value)) {
                              setValue("mob", value, {
                                shouldValidate: true,
                              });
                            }
                          },
                        })}
                      />
                      {errors.mob && (
                        <div className="errorMessage">
                          {errors.mob.message}
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="saveButtons mt-3">
                    <button
                      type="button"
                      className="saveBtn btn-secondary mr-2"
                      onClick={handleSaveDraft}
                    >
                      Save As Draft
                    </button>
                    <button type="submit" className="saveNextBtn btn-primary">
                      Save And Next
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>

      <ToastContainer />
    </div>

  );
}
